
import React, { useState, useEffect } from "react";
import holidayService from "../../services/holidayService";
import { getErrorMessage } from "../../utils/errorHandler";
import {
  Plus,
  Edit2,
  Trash2,
  Calendar,
  Filter,
  CheckCircle2,
  ShieldAlert,
  X,
  Save
} from "lucide-react";
import "../../styles/dashboard.css";

const HolidaysManagement = () => {
  // ============================================================
  // États
  // ============================================================

  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [showForm, setShowForm] = useState(false);
  const [editingHoliday, setEditingHoliday] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    date: "",
    holiday_type: "NATIONAL",
    payment_status: "PAID",
    description: "",
    duration_days: 1,
    is_active: true,
    is_religious: false
  });

  const [filterYear, setFilterYear] = useState(
    new Date().getFullYear().toString()
  );

  const [filterType, setFilterType] = useState("");

  // ============================================================
  // Chargement des jours fériés
  // ============================================================

  useEffect(() => {
    loadHolidays();
  }, [filterYear, filterType]);

  const loadHolidays = async () => {
    try {
      setLoading(true);
      setError("");

      const data = await holidayService.getHolidays(
        filterYear ? parseInt(filterYear, 10) : null,
        filterType || null
      );

      console.log(
        "[HolidaysManagement] Jours fériés récupérés :",
        data
      );


      console.table(
      data.map((h) => ({
        id: h.id,
        name: h.name,
        payment_status: h.payment_status,
        details_payment_status: h.details?.payment_status,
      }))
    );


      setHolidays(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(
        "[HolidaysManagement] Erreur chargement jours fériés :",
        err
      );

      setError(getErrorMessage(err));
      setHolidays([]);
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // Réinitialiser le formulaire
  // ============================================================

  const resetForm = () => {
    setFormData({
      name: "",
      date: "",
      holiday_type: "NATIONAL",
      payment_status: "PAID",
      description: "",
      duration_days: 1,
      is_active: true,
      is_religious: false
    });

    setEditingHoliday(null);
  };

  // ============================================================
  // Ajouter un jour férié
  // ============================================================

  const handleAdd = () => {
    console.log(
      "[HolidaysManagement] Ajout nouveau jour férié"
    );

    setError("");
    setSuccess("");

    resetForm();

    setShowForm(true);
  };

  // ============================================================
  // Modifier un jour férié
  // ============================================================

  const handleEdit = (holiday) => {
    console.log(
      "[HolidaysManagement] Modification du jour férié :",
      holiday
    );

    setError("");
    setSuccess("");

    setEditingHoliday(holiday);

    setFormData({
      name: holiday.name || "",

      date: holiday.date
        ? String(holiday.date).substring(0, 10)
        : "",

      holiday_type:
        holiday.holiday_type || "NATIONAL",

      payment_status: getPaymentStatus(holiday),

      description:
        holiday.description || "",

      duration_days:
        holiday.duration_days || 1,

      is_active:
        holiday.is_active ?? true,

      is_religious:
        holiday.is_religious ?? false
    });

    setShowForm(true);
  };

  // ============================================================
  // Gestion des champs du formulaire
  // ============================================================
const getPaymentStatus = (holiday) => {
  const status =
    holiday?.payment_status ??
    holiday?.details?.payment_status;

  return String(status || "PAID").trim().toUpperCase();
};
  const handleChange = (e) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : value
    }));
  };

  // ============================================================
  // Annuler
  // ============================================================

  const handleCancel = () => {
    console.log(
      "[HolidaysManagement] Annulation formulaire"
    );

    setShowForm(false);
    setEditingHoliday(null);
    setError("");
  };

  // ============================================================
  // Enregistrer : Ajouter / Modifier
  // ============================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Vérifications
    if (!formData.name.trim()) {
      setError("Le nom du jour férié est obligatoire.");
      return;
    }

    if (!formData.date) {
      setError("La date du jour férié est obligatoire.");
      return;
    }

    if (
      !Number.isInteger(Number(formData.duration_days)) ||
      Number(formData.duration_days) < 1
    ) {
      setError(
        "La durée doit être un nombre entier supérieur ou égal à 1 jour."
      );
      return;
    }

    if (!["PAID", "UNPAID"].includes(formData.payment_status)) {
      setError("Veuillez sélectionner le régime de rémunération.");
      return;
    }

    try {
      setSaving(true);
      setError("");
      setSuccess("");

      /*
       * IMPORTANT :
       * On envoie uniquement les champs actuellement
       * supportés par HolidayCreate / HolidayUpdate.
       */
      const holidayData = {
        name: formData.name.trim(),
        date: formData.date,
        holiday_type: formData.holiday_type,
        payment_status: formData.payment_status,
        description: formData.description || null,
        year: new Date(formData.date).getFullYear(),
        duration_days: Number(formData.duration_days),
        is_active: Boolean(formData.is_active),
        is_religious: Boolean(formData.is_religious),
      };

      // ========================================================
      // MODIFICATION
      // ========================================================

      if (editingHoliday) {
        console.log(
          "[HolidaysManagement] PUT /holidays/",
          editingHoliday.id
        );


              console.log(
        "[HolidaysManagement] PAYLOAD PUT :",
        JSON.stringify(holidayData, null, 2)
      );
const updatedHoliday = await holidayService.updateHoliday(
  editingHoliday.id,
  holidayData
);

console.log("[HOLIDAYS] REPONSE PUT :", updatedHoliday);
        setSuccess(
          "Jour férié modifié avec succès."
        );
      }

      // ========================================================
      // AJOUT
      // ========================================================

      else {
        console.log(
          "[HolidaysManagement] POST /holidays"
        );

        await holidayService.createHoliday(
          holidayData
        );

        setSuccess(
          "Jour férié ajouté avec succès."
        );
      }

      // Fermer le formulaire
      setShowForm(false);
      setEditingHoliday(null);

      // Recharger la liste
      await loadHolidays();

      // Effacer le message après 3 secondes
      setTimeout(() => {
        setSuccess("");
      }, 3000);

    } catch (err) {
        console.error(
          "[HolidaysManagement] Erreur sauvegarde :",
          err
        );

        console.error(
          "[HolidaysManagement] HTTP STATUS :",
          err?.response?.status
        );

        const details = err?.response?.data?.detail;

        console.error(
          "[HolidaysManagement] ERREUR VALIDATION BACKEND :",
          JSON.stringify(details, null, 2)
        );

        let errorMessage = getErrorMessage(err);

        if (Array.isArray(details)) {
          errorMessage = details
            .map((item) => {
              const field = Array.isArray(item.loc)
                ? item.loc.join(".")
                : "Champ inconnu";

              return `${field} : ${item.msg || "Erreur de validation"}`;
            })
            .join("\n");
        } else if (typeof details === "string") {
          errorMessage = details;
        }

        setError(errorMessage);

      } finally {
        setSaving(false);
      }
  };

  // ============================================================
  // Supprimer un jour férié
  // ============================================================

  const handleDelete = async (holidayId) => {
    const confirmed = window.confirm(
      "Êtes-vous sûr de vouloir supprimer ce jour férié ?"
    );

    if (!confirmed) {
      return;
    }

    try {
      setError("");
      setSuccess("");

      console.log(
        "[HolidaysManagement] DELETE /holidays/",
        holidayId
      );

      await holidayService.deleteHoliday(
        holidayId
      );

      setSuccess(
        "Jour férié supprimé avec succès."
      );

      await loadHolidays();

      setTimeout(() => {
        setSuccess("");
      }, 3000);

    } catch (err) {
      console.error(
        "[HolidaysManagement] Erreur suppression :",
        err
      );

      setError(
        getErrorMessage(err)
      );
    }
  };

  // ============================================================
  // Libellé du type
  // ============================================================

  const getHolidayTypeLabel = (type) => {
    const labels = {
      NATIONAL: "National",
      RELIGIOUS: "Religieux",
      INTERNE_ENTREPRISE: "Interne entreprise",
    };

    return labels[type] || type || "-";
  };

  // ============================================================
  // Couleur du type
  // ============================================================

  const getHolidayTypeColor = (type) => {
    const colors = {
      NATIONAL: {
        bg: "#dbeafe",
        text: "#1e40af"
      },

      RELIGIOUS: {
        bg: "#fef3c7",
        text: "#92400e"
      },

      INTERNE_ENTREPRISE: {
        bg: "#e0e7ff",
        text: "#3730a3"
      },

    };

    return (
      colors[type] || {
        bg: "#f3f4f6",
        text: "#374151"
      }
    );
  };

  // ============================================================
  // Format date
  // ============================================================

  const formatDate = (date) => {
    if (!date) {
      return "-";
    }

    try {
      return new Date(date).toLocaleDateString(
        "fr-FR"
      );
    } catch {
      return date;
    }
  };

  // ============================================================
  // Chargement
  // ============================================================

  if (loading) {
    return (
      <div
        className="flex-center-all"
        style={{
          height: "100vh",
          background: "#f8fafc",
          flexDirection: "column"
        }}
      >
        <div
          className="spinner"
          style={{
            width: "40px",
            height: "40px",
            border: "4px solid #e2e8f0",
            borderTopColor: "#10b981",
            borderRadius: "50%"
          }}
        ></div>

        <p
          style={{
            marginTop: "15px",
            color: "#64748b",
            fontFamily: "sans-serif"
          }}
        >
          Chargement des jours fériés...
        </p>
      </div>
    );
  }

  // ============================================================
  // Interface
  // ============================================================

  return (
    <div style={{ padding: "24px" }}>

      {/* ======================================================
          EN-TÊTE
      ====================================================== */}

      <div
        className="card-box-header"
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <div>
          <h2
            style={{
              fontSize: "1.8rem",
              color: "#1e293b",
              fontWeight: "600",
              marginBottom: "6px"
            }}
          >
            Gestion des jours fériés
          </h2>

          <p style={{ margin: 0 }}>
            Consultez et gérez les jours fériés
            de l'entreprise
          </p>
        </div>

    
      </div>

      {/* ======================================================
          MESSAGE SUCCÈS
      ====================================================== */}

      {success && (
        <div
          className="flash-success-toast"
          style={{
            marginBottom: "20px"
          }}
        >
          <CheckCircle2
            size={20}
            className="toast-icon"
          />

          <span>{success}</span>
        </div>
      )}

      {/* ======================================================
          MESSAGE ERREUR
      ====================================================== */}

      {error && (
        <div
          className="form-error-box"
          style={{
            marginBottom: "20px"
          }}
        >
          <ShieldAlert size={18} />

          <span>{error}</span>
        </div>
      )}

      {/* ======================================================
          FORMULAIRE AJOUT / MODIFICATION
      ====================================================== */}

      {showForm && (
        <div
          className="card-inner-box"
          style={{
            padding: "24px",
            marginBottom: "20px",
            border: "1px solid #e2e8f0"
          }}
        >
          {/* En-tèªte formulaire */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px"
            }}
          >
            <div>
              <h3
                style={{
                  margin: 0,
                  fontSize: "1.3rem",
                  color: "#1e293b"
                }}
              >
                {editingHoliday
                  ? "Modifier le jour férié"
                  : "Nouveau jour férié"}
              </h3>

              <p
                style={{
                  marginTop: "5px",
                  marginBottom: 0,
                  color: "#64748b"
                }}
              >
                {editingHoliday
                  ? "Modifiez les informations du jour férié."
                  : "Ajoutez un nouveau jour férié."}
              </p>
            </div>

            <button
              type="button"
              onClick={handleCancel}
              className="btn btn-small"
              title="Fermer"
            >
              <X size={18} />
            </button>
          </div>

          {/* Formulaire */}

          <form onSubmit={handleSubmit}>

            {/* Ligne 1 */}

            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "20px"
              }}
            >

              {/* Nom */}

              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "7px",
                    fontWeight: "500",
                    color: "#374151"
                  }}
                >
                  Nom du jour férié *
                </label>

                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Ex : Fête de l'Indépendance"
                  required
                />
              </div>

              {/* Date */}

              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "7px",
                    fontWeight: "500",
                    color: "#374151"
                  }}
                >
                  Date *
                </label>

                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  className="form-input"
                  required
                />
              </div>

              {/* Type */}

              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "7px",
                    fontWeight: "500",
                    color: "#374151"
                  }}
                >
                  Type *
                </label>

                <select
                  name="holiday_type"
                  value={formData.holiday_type}
                  onChange={handleChange}
                  className="form-select"
                  required
                >
                  <option value="NATIONAL">
                    National
                  </option>

                  <option value="RELIGIOUS">
                    Religieux
                  </option>

                  <option value="INTERNE_ENTREPRISE">
                    Interne entreprise
                  </option>

                </select>
              </div>

              {/* Durée */}

              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "7px",
                    fontWeight: "500",
                    color: "#374151"
                  }}
                >
                  Durée (jours) *
                </label>

                <input
                  type="number"
                  name="duration_days"
                  min="1"
                  value={formData.duration_days}
                  onChange={handleChange}
                  className="form-input"
                  required
                />
              </div>
            </div>

            {/* Rémunération : indépendante de la catégorie */}

            <div
              style={{
                marginTop: "18px",
                marginBottom: "20px",
                padding: "14px 16px",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                background: "#f8fafc",
              }}
            >
              <label
                style={{
                  display: "block",
                  marginBottom: "12px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Régime de rémunération *
              </label>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "28px",
                  flexWrap: "wrap",
                }}
              >
                <label
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: saving ? "not-allowed" : "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name="payment_status"
                    value="PAID"
                    checked={formData.payment_status === "PAID"}
                    onChange={handleChange}
                    disabled={saving}
                    required
                  />
                  <span style={{ color: "#166534", fontWeight: "500" }}>
                    Chômé payé
                  </span>
                </label>

                <label
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: saving ? "not-allowed" : "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name="payment_status"
                    value="UNPAID"
                    checked={formData.payment_status === "UNPAID"}
                    onChange={handleChange}
                    disabled={saving}
                    required
                  />
                  <span style={{ color: "#991b1b", fontWeight: "500" }}>
                    Chômé non payé
                  </span>
                </label>
              </div>

              <small
                style={{
                  display: "block",
                  marginTop: "8px",
                  color: "#64748b",
                }}
              >
                La rémunération est indépendante de la catégorie du jour férié.
              </small>
            </div>

            {/* Description */}

            <div
              style={{
                marginTop: "20px"
              }}
            >
              <label
                style={{
                  display: "block",
                  marginBottom: "7px",
                  fontWeight: "500",
                  color: "#374151"
                }}
              >
                Description
              </label>

              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                className="form-input"
                rows="3"
                placeholder="Description du jour férié..."
                style={{
                  resize: "vertical",
                  width: "100%"
                }}
              />
            </div>

            {/* Options */}

            <div
              style={{
                display: "flex",
                gap: "25px",
                flexWrap: "wrap",
                marginTop: "20px"
              }}
            >

              {/* Actif */}

              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer"
                }}
              >
                <input
                  type="checkbox"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleChange}
                />

                <span>
                  Jour férié actif
                </span>
              </label>

              {/* Religieux */}

              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer"
                }}
              >
                <input
                  type="checkbox"
                  name="is_religious"
                  checked={formData.is_religious}
                  onChange={handleChange}
                />

                <span>
                  Jour religieux
                </span>
              </label>
            </div>

            {/* Boutons */}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "25px"
              }}
            >
              <button
                type="button"
                onClick={handleCancel}
                className="btn"
                disabled={saving}
              >
                <X size={17} />
                Annuler
              </button>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={saving}
              >
                <Save size={17} />

                {saving
                  ? "Enregistrement..."
                  : editingHoliday
                    ? "Enregistrer les modifications"
                    : "Ajouter le jour férié"}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* ======================================================
          FILTRES
      ====================================================== */}

      <div
        className="card-inner-box"
        style={{
          padding: "20px",
          marginBottom: "20px"
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "15px",
            alignItems: "center",
            flexWrap: "wrap"
          }}
        >

          {/* Label */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            <Filter
              size={18}
              style={{
                color: "#64748b"
              }}
            />

            <span
              style={{
                fontSize: "0.9rem",
                color: "#64748b",
                fontWeight: "500"
              }}
            >
              Filtres :
            </span>
          </div>

          {/* Année */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            <label
              style={{
                fontSize: "0.85rem",
                color: "#475569"
              }}
            >
              Année :
            </label>

            <select
              value={filterYear}
              onChange={(e) =>
                setFilterYear(e.target.value)
              }
              className="form-select"
              style={{
                padding: "6px 12px",
                fontSize: "0.9rem"
              }}
            >
              <option value="">
                Toutes
              </option>

              <option value="2024">
                2024
              </option>

              <option value="2025">
                2025
              </option>

              <option value="2026">
                2026
              </option>

              <option value="2027">
                2027
              </option>

              <option value="2028">
                2028
              </option>
            </select>
          </div>

          {/* Type */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <label
              style={{
                fontSize: "0.85rem",
                color: "#475569",
              }}
            >
              Type :
            </label>

            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              className="form-select"
              style={{
                padding: "6px 12px",
                fontSize: "0.9rem",
              }}
            >
              <option value="">Tous</option>
              <option value="NATIONAL">National</option>
              <option value="RELIGIOUS">Religieux</option>
              <option value="INTERNE_ENTREPRISE">Interne entreprise</option>
            </select>
          </div>

          {/* Bouton d'ajout : ouvre le formulaire déjà présent */}
          <button
            type="button"
            onClick={handleAdd}
            disabled={saving}
            className="btn btn-primary"
            style={{
              marginLeft: "auto",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "9px",
              padding: "10px 18px",
              borderRadius: "8px",
              fontWeight: "600",
              whiteSpace: "nowrap",
              background: "#2563eb",
              color: "#ffffff",
              border: "none",
              cursor: saving ? "not-allowed" : "pointer",
              opacity: saving ? 0.6 : 1,
              boxShadow: "0 2px 5px rgba(37, 99, 235, 0.2)"
            }}
          >
            <Plus size={18} />
            Ajouter un jour férié
          </button>

        </div>
      </div>

      {/* ======================================================
          LISTE DES JOURS FÉRIÉS
      ====================================================== */}

      <div
        className="card-inner-box"
        style={{
          padding: "20px"
        }}
      >
        {holidays.length === 0 ? (

          <div
            style={{
              textAlign: "center",
              padding: "40px",
              color: "#9ca3af"
            }}
          >
            <Calendar
              size={48}
              style={{
                margin: "0 auto 15px",
                opacity: 0.5
              }}
            />

            <p>
              Aucun jour férié trouvé
            </p>

    
          </div>

        ) : (

          <div
            style={{
              overflowX: "auto"
            }}
          >
            <table className="modern-table">

              <thead>
                <tr>
                  <th>Nom</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Rémunération</th>
                  <th>Durée</th>
                  <th>Description</th>
                  <th>Statut</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>

                {holidays.map((holiday) => {


                  const paymentStatus = 
                  getPaymentStatus(holiday);


                  const typeColor =
                    getHolidayTypeColor(
                      holiday.holiday_type
                    );

                  return (
                    <tr key={holiday.id}>

                      {/* Nom */}

                      <td
                        style={{
                          fontWeight: "600"
                        }}
                      >
                        {holiday.name}
                      </td>

                      {/* Date */}

                      <td>
                        {formatDate(
                          holiday.date
                        )}
                      </td>

                      {/* Type */}

                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 10px",
                            borderRadius: "12px",
                            fontSize: "0.85rem",
                            fontWeight: "500",
                            background:
                              typeColor.bg,
                            color:
                              typeColor.text
                          }}
                        >
                          {getHolidayTypeLabel(
                            holiday.holiday_type
                          )}
                        </span>
                      </td>
                      {/* Rémunération */}

                                          <td>
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 10px",
                          borderRadius: "12px",
                          fontSize: "0.85rem",
                          fontWeight: "500",
                          background:
                            paymentStatus === "UNPAID" ? "#fee2e2" : "#dcfce7",
                          color:
                            paymentStatus === "UNPAID" ? "#991b1b" : "#166534",
                        }}
                      >
                        {paymentStatus === "UNPAID"
                          ? "Chômé non payé"
                          : "Chômé payé"}
                      </span>
                    </td>
                
                      {/* Durée */}

                      <td>
                        {holiday.duration_days || 1}
                        {" "}
                        jour
                        {(holiday.duration_days || 1) > 1
                          ? "s"
                          : ""}
                      </td>

                      {/* Description */}

                      <td
                        style={{
                          color: "#64748b",
                          fontSize: "0.9rem"
                        }}
                      >
                        {holiday.description || "-"}
                      </td>

                      {/* Statut */}

                      <td>
                        {holiday.is_active ? (
                          <span
                            style={{
                              color: "#166534",
                              background: "#dcfce7",
                              padding: "4px 9px",
                              borderRadius: "10px",
                              fontSize: "0.8rem",
                              fontWeight: "500"
                            }}
                          >
                            Actif
                          </span>
                        ) : (
                          <span
                            style={{
                              color: "#991b1b",
                              background: "#fee2e2",
                              padding: "4px 9px",
                              borderRadius: "10px",
                              fontSize: "0.8rem",
                              fontWeight: "500"
                            }}
                          >
                            Inactif
                          </span>
                        )}
                      </td>

                      {/* Actions */}

                      <td>
                        <div
                          style={{
                            display: "flex",
                            gap: "8px"
                          }}
                        >

                          {/* Modifier */}

                          <button
                            onClick={() =>
                              handleEdit(
                                holiday
                              )
                            }
                            className="btn btn-small"
                            title="Modifier"
                            type="button"
                          >
                            <Edit2 size={16} />
                          </button>

                          {/* Supprimer */}

                          <button
                            onClick={() =>
                              handleDelete(
                                holiday.id
                              )
                            }
                            className="btn btn-small btn-danger"
                            title="Supprimer"
                            type="button"
                          >
                            <Trash2 size={16} />
                          </button>

                        </div>
                      </td>

                    </tr>
                  );
                })}

              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default HolidaysManagement;


